// document.querySelectorAll('header-menu details').forEach(details => {
//   details.addEventListener('mouseover', () => {
//     details.setAttribute('open', true);
//   });
//   details.addEventListener('mouseleave', () => {
//     details.removeAttribute('open');
//   });
// });


// $(document).on('click', '.ct-atc_show_btn', function() {
//   $(this).parents('.ct-buy-btn').find('.ct-quantity_btn').show();
//   $(this).parents('.ct-buy-btn').find('.ct-product-form-one').show();
//   $(this).hide();
// });

$(document).on('click', '.ct_bundle_select_option_head', function() {
  $(this).siblings('.ct_bundle_select_option_wrp').slideToggle();
  $(this).toggleClass('active');
});


$(document).on('click', '.ct-main-sticky_atc_button', function() {
  $(this).parents('.ct-main-product').find('.ct-buy-btn .product-form__submit').trigger('click');
});

$(document).on('click', '.byob_category_item', function () {

    $('.byob_category_item').removeClass('active');
    $(this).addClass('active');

    // ALL button
    if ($(this).hasClass('byob_category_item_all')) {

        $('.all_cstm-product_item').css('display', 'block');

    } else {

        let category = $(this).data('button');

        $('.all_cstm-product_item').css('display', 'none');

        $('.all_cstm-product_item[data-category="' + category + '"]')
            .css('display', 'flex');
    }

});



document.addEventListener('DOMContentLoaded', () => {

  const input = document.querySelector('#Search-In-Modal');

  if (!input) return;

  const words = [
    'Bestsellers',
    'Popular Searched',
    'Perfumes',
    'Gift Sets',
    'Luxury Fragrances'
  ];

  let wordIndex = 0;
  let charIndex = 0;
  let deleting = false;

  function animatePlaceholder() {

    const currentWord = words[wordIndex];

    if (!deleting) {

      input.placeholder =
        'Search for ' + currentWord.substring(0, charIndex + 1);

      charIndex++;

      if (charIndex === currentWord.length) {
        deleting = true;
        setTimeout(animatePlaceholder, 1200);
        return;
      }

    } else {

      input.placeholder =
        'Search for ' + currentWord.substring(0, charIndex - 1);

      charIndex--;

      if (charIndex === 0) {
        deleting = false;
        wordIndex = (wordIndex + 1) % words.length;
      }

    }

    setTimeout(
      animatePlaceholder,
      deleting ? 60 : 100
    );
  }

  animatePlaceholder();

});



if (document.querySelector('#store-search')){
  document.addEventListener("DOMContentLoaded", () => {
    let activeTab = "all";
    let searchTerm = "";
    function filterStores() {
      document.querySelectorAll(".store-card:not(.find-store-card)").forEach((card) => {
        const city =
          card.dataset.city || "";
        const state =
          card.dataset.state || "";
        const pincode =
          card.dataset.pincode || "";
        const tabMatch =
          activeTab === "all" ||
          city === activeTab;
        const searchMatch =
          city.includes(searchTerm) ||
          state.includes(searchTerm) ||
          pincode.includes(searchTerm);
        if (
          tabMatch &&
          (
            searchTerm === "" ||
            searchMatch
          )
        ) {
          card.style.display = "";
        } else {
          card.style.display = "none";
        }
      });
    }
    document.querySelectorAll(".store-tab").forEach((tab) => {
      tab.addEventListener("click", () => {
        document.querySelectorAll(".store-tab").forEach((btn) =>
            btn.classList.remove("active")
          );
        tab.classList.add("active");
        activeTab = tab.dataset.city;
        filterStores();
      });
    });
    document.getElementById("store-search").addEventListener("input", (e) => {
      searchTerm =  e.target.value.toLowerCase();
      filterStores();
    });
  });
}

$(document).on('click', '.read-more-less_btn', function () {
  $(this).toggleClass('active');
  $(this).parents('.review-content_Wrp').find('.review-text').toggleClass('active');
});
